/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Account_TitleInputs */

const da_terms_account_title = /** @type {(inputs: Terms_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

/** @type {(inputs: Terms_Account_TitleInputs) => LocalizedString} */
const en_terms_account_title = da_terms_account_title;

/**

* @param {Terms_Account_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_account_title = /** @type {((inputs?: Terms_Account_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Account_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_account_title(inputs)
	return /** @type {LocalizedString} */ ("Konto")
});